/**
 * Replace these with real quotes from real families, then drop `isPlaceholder`.
 *
 * Anything still marked `isPlaceholder` is filtered out of a production build — see
 * `visibleTestimonials` below. Invented testimonials on a real business page would mislead
 * the parents this site is meant to reassure, so they cannot ship by accident: if no real
 * quotes exist, the section simply does not render.
 */
export type Testimonial = {
  quote: string;
  attribution: string;
  detail?: string;
  isPlaceholder?: boolean;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Placeholder — a few sentences from a family about how Courtney settled into their routine' +
      ' and what their child got out of it.',
    attribution: 'Parent of two',
    detail: 'Atlanta, GA',
    isPlaceholder: true,
  },
  {
    quote:
      'Placeholder — a quote about trust and reliability works well here: being on time, being' +
      ' steady, being someone they were glad to come home to.',
    attribution: 'Nanny family',
    detail: 'Smyrna, GA',
    isPlaceholder: true,
  },
  {
    quote:
      'Placeholder — a note from a colleague or director at one of the schools carries a' +
      ' different kind of weight than a parent quote.',
    attribution: 'Former colleague',
    detail: 'Primrose School',
    isPlaceholder: true,
  },
];

/**
 * Placeholders are visible while developing so the section can be styled, and stripped from
 * the built site.
 */
export const visibleTestimonials: Testimonial[] = import.meta.env.DEV
  ? testimonials
  : testimonials.filter((testimonial) => !testimonial.isPlaceholder);
